import React from 'react';
import { useCommonContext } from '../../contexts/common';
import MenuGroup from "./menu-group"
import styles from "./MainMenu.module.css"
import ScrollView from 'devextreme-react/scroll-view';
const MainMenu = () => {
    const { menuItems, translate } = useCommonContext();

    return (
        <ScrollView height={window.innerHeight - 50} >
            <div className={styles.main_menu} style={{
                height: window.innerHeight - 50
            }}>
                <MenuGroup key={0} group={{
                    expanded: true,
                    items: [{
                        name: "Trang chủ",
                        icon: "fas fa-home",
                        path: "home"
                    }]
                }} />
                {menuItems.map((x, idx) => {
                    return (
                        <MenuGroup key={idx} group={x} />
                    )
                })}
            </div>
        </ScrollView>
    );
};

export default MainMenu;